module.exports = __webpack_public_path__ + "static/10-5bbfbe10115bf292328ec9df35ed9c1c.jpg";